var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('base-navigator-drawer'),_c('base-top-navigator-bar'),_c('v-main',[_vm._t("default"),_c('top-gainer-section'),_c('section',{staticClass:"agents"},[_c('v-row',_vm._l(([
              'ag.png',
              'betsoft.png',
              'bg.png',
              'blueprint.png',
              'dream_gamming.png',
              'evoplay.png',
              'funky_play.png',
              'gamatron.png',
              'gameplay.png',
              'gdg.png',
              'gg_fishing.png',
              'green_dragon.png',
              'habanero.png',
              'iron_dog.png',
              'joker.png',
              'kalamba.png',
              'maverick.png',
              'microgaming.png',
              'n2.png',
              'pg.png',
              'playstart.png',
              'pragmatic.png',
              'quickspin.png',
              'red_tiger.png',
              'relax_gaming.png',
              'sa.png',
              'sexy_gaming.png',
              'simpleplay.png',
              'toptrend.png',
              'wm.png',
              'yggdrasil.png' ]),function(studio,index){return _c('v-col',{key:index,attrs:{"cols":"3","md":"1"}},[_c('img',{attrs:{"width":"100%","src":require(("@/assets/studio_logos/" + studio)),"alt":""}})])}),1)],1),_c('base-footer'),_c('base-footer-navigator',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.mdAndDown),expression:"$vuetify.breakpoint.mdAndDown"}]})],2),_c('dialog-connector',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
            var possibleDialog = ref.possibleDialog;
return [_c('dialog-connector',{scopedSlots:_vm._u([_vm._l((possibleDialog),function(dialog){return {key:dialog,fn:function(ref){
            var open = ref.open;
            var closeDialog = ref.closeDialog;
            var dialogType = ref.dialogType;
            var dialogData = ref.dialogData;
return [(dialogType === dialog)?_c(dialog,{key:dialog,tag:"component",attrs:{"open":open,"dialogData":dialogData},on:{"close-dialog":function($event){return closeDialog()}}}):_vm._e()]}}})],null,true)})]}}])}),_c('base-snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }